export const EDIT_LEVEL = "EDIT_LEVEL"
export const EDIT_LEVEL_SUCCESS = "EDIT_LEVEL_SUCCESS"
export const EDIT_LEVEL_CLEAN = "EDIT_USER_CLEAN"
export const EDIT_LEVEL_ERROR = "EDIT_LEVEL_ERROR"
